import React from 'react';
import { URL_BASE } from '../../../config';
import axios from 'axios';
import s from './StaffActions.scss';
import Modal from '../Common/Modal';
import Button from '../Common/Button';
import RadioGroup from '../Common/RadioGroup';
import BtnS from '../Common/Button.scss';
import arrow_up from '../../../assets/images/icons/Arrow_up_2grey.svg';
import arrow_down from '../../../assets/images/icons/Arrow_down_2grey.svg';

const StaffActions = ({ updateDealPipedrive, requestInspection, showMenu, toggleMenu, has_user, createUser, userError, userModal, closeUsermodal, handleUserError, requestVeraz }) => {

    const logoutUser = (e) => {
        e.preventDefault();
         axios.get('/api/v3/auth/logout/')
        .then(() => {
           window.location.href = "/";
        });
    }

    return(
    <div className={s.container}>
        <div className={s.profileBut}>
                <p>
                    <a className={s.openLink} onClick={toggleMenu}>Acciones de Staff
                    {(showMenu) ? <img className={s.arrowIcon} src={arrow_up} alt='flecha hacia arriba'/> : <img className={s.arrowIcon} src={arrow_down} alt='flecha hacia abajo'/>}
                    </a>
                </p>

            </div>

        {showMenu &&
            <div className={s.box}>
                <ul>
                    <li><a onClick={updateDealPipedrive}>Actualizar deal en Pipedrive</a></li>
                    <li><a onClick={requestInspection}>Solicitar Inspección en Tecnored</a></li>
                    <li><a onClick={requestVeraz}>Solicitar Veraz</a></li>
                    <li><a href={'/'}>Cambiar tipo de prestamo</a></li>
                    <li><a href={`${URL_BASE}/app/clear-app/`}> Nueva aplicación</a></li>
                    <li>{!has_user ? <a onClick={createUser}> Crear usuario</a> : <a style={{color: "#555"}}>Crear usuario</a>}</li>
                    <li><a onClick={logoutUser}> Cerrar sesión</a></li>
                </ul>
            </div>
        }
        {userError && <Modal showModal={userModal} closeModal={closeUsermodal}>
            <p className={s.userError}>{userError && userError}</p>
            <Button onClick={handleUserError} >
                Modificar
            </Button>
        </Modal>}
    </div>
);
}
export default StaffActions;
